export const footerBrandName: string = 'LetsBetMd';
